import React from "react";

const Heading = ({ heading, fontSize = "3rem", fontWeight = "300" }) => {
  return (
    <h1
      style={{
        fontSize: fontSize,
        margin: 0,
        fontWeight,
        textAlign: "center",
      }}
    >
      {heading}
    </h1>
  );
};

export default Heading;
